const UploadErrorList = ({ errors = [] }) => {
  if (!errors?.length) {
    return null;
  }

  return (
    <div className="upload-error-list">
      <div className="error-header">
        <h3>Upload Errors</h3>

        <span>
          {errors.length} error{errors.length !== 1 ? "s" : ""} found
        </span>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Row</th>
              <th>Field</th>
              <th>Error Message</th>
            </tr>
          </thead>

          <tbody>
            {errors.map((error, index) => (
              <tr key={index}>
                <td>
                  {error.rowNumber ?? "General"}
                </td>

                <td>
                  {error.field || "-"}
                </td>

                <td>
                  {error.message || "Unknown error"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UploadErrorList;